
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/knowledge-base/[category]/[...slug]",
      function () {
        return require("private-next-pages/knowledge-base/[category]/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/knowledge-base/[category]/[...slug]"])
      });
    }
  